import type { Dispatch } from 'react';
import { dispatchBulkAdd } from './dispatchers';
import type { Action } from './types';

export const addBulkItems = (validItems: string[], prevValue: string[], dispatch: Dispatch<Action>) => {
  const validItemsMapped = validItems.map(item => ({ id: item, name: item, isOnList: true }));
  const updatedValue = [...prevValue, ...validItems];

  dispatchBulkAdd(dispatch, validItemsMapped);
  return updatedValue;
};
